"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexiPie = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _recharts = require("recharts");

var _theme = require("../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    background: rgba(32,39,46,0.9);\n    color: #fff;\n    padding: 4px 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    & .boldText{\n        font-weight: bold;\n        font-size: 1.2em;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlexiWrapper = _styledComponents["default"].div(_templateObject());

var CustomTooltipWrapper = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.theme.PrimaryRadius;
});

var shader = function shader(col) {
  var shader = [];

  for (var w = 0; w < 5; w++) {
    shader.push((0, _polished.transparentize)(w * 0.2, col));
  }

  return shader;
};

var dataRender = function dataRender(data, colors) {
  var newdata;
  newdata = data.map(function (elem, id) {
    return _objectSpread(_objectSpread({}, elem), {}, {
      fill: elem.fill ? elem.fill : colors[id]
    });
  });
  return newdata;
};

var CustomTooltip = function CustomTooltip(_ref) {
  var active = _ref.active,
      payload = _ref.payload,
      label = _ref.label;

  if (active && payload && payload.length) {
    var _payload$0$value;

    return /*#__PURE__*/_react["default"].createElement(CustomTooltipWrapper, {
      className: "custom-tooltip"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "label"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, "".concat(payload[0].name)), ": ".concat((_payload$0$value = payload[0].value) === null || _payload$0$value === void 0 ? void 0 : _payload$0$value.toLocaleString())));
  }

  return null;
};

var FlexiPie = function FlexiPie(props) {
  var data;

  var stroke = props.stroke,
      others = _objectWithoutProperties(props, ["stroke"]);

  data = (0, _react.useMemo)(function () {
    return props.data ? props.data : props.yData.map(function (elem, id) {
      return _objectSpread({
        name: props.xData[id]
      }, elem);
    });
  }, [props.data, props.yData]);
  var i = -1;
  var colors = props.shade ? typeof props.shade === 'string' ? shader(props.shade) : shader(_theme.FlexTheme.PrimaryColor) : props.colors;
  return /*#__PURE__*/_react["default"].createElement(FlexiWrapper, null, /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: props.radius * 2 + 20
  }, /*#__PURE__*/_react["default"].createElement(_recharts.PieChart, others, props.tooltip && (props.tooltip === 'light' ? /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    contentStyle: {
      background: 'rgba(255,255,255,0.9)',
      borderRadius: '3px',
      border: 'none',
      padding: '15px',
      boxShadow: '1px 2px 10px rgba(0,0,0,0.2)'
    },
    itemStyle: {
      color: "#333"
    },
    cursor: {
      opacity: 0.05,
      fill: 'rgba(0,0,0,0.9)'
    },
    allowEscapeViewBox: {
      x: false,
      y: true
    },
    content: props.formattedTooltip ? /*#__PURE__*/_react["default"].createElement(CustomTooltip, null) : false
  }) : /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    contentStyle: {
      background: 'rgba(32,39,46,0.9)',
      borderRadius: '3px',
      border: 'none',
      padding: '15px',
      boxShadow: '1px 2px 10px rgba(0,0,0,0.2)'
    },
    itemStyle: {
      color: "#fff"
    },
    cursor: {
      opacity: 0.05,
      fill: 'rgba(0,0,0,0.9)'
    },
    allowEscapeViewBox: {
      x: false,
      y: true
    },
    content: props.formattedTooltip ? /*#__PURE__*/_react["default"].createElement(CustomTooltip, null) : false
  })), props.children, Object.keys(data[0]).map(function (key, index) {
    if (key != "name" && key != "fill") {
      var _props$center;

      i++;
      var outerRadius = props.radius - props.thickness * (index - 1);
      var newData = dataRender(data, colors);
      return /*#__PURE__*/_react["default"].createElement(_recharts.Pie, {
        data: newData,
        key: "data-".concat(key, "-").concat(index),
        opacity: 1 - 0.2 * (index - 1),
        nameKey: "name",
        dataKey: key,
        strokeWidth: stroke ? 1 : 0,
        cx: "50%",
        cy: "50%",
        outerRadius: outerRadius,
        innerRadius: props.doughnut ? outerRadius - props.thickness : 0,
        fill: colors[index]
      }, props.center && /*#__PURE__*/_react["default"].createElement(_recharts.Label, {
        position: "center",
        dy: -10,
        className: "boldText"
      }, props.center.value), ((_props$center = props.center) === null || _props$center === void 0 ? void 0 : _props$center.label) && /*#__PURE__*/_react["default"].createElement(_recharts.Label, {
        value: props.center.label,
        dy: 10,
        position: "center"
      }));
    } else {
      return null;
    }
  }), props.legend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, {
    align: "right",
    verticalAlign: "top",
    layout: "vertical"
  }))));
};

exports.FlexiPie = FlexiPie;
FlexiPie.defaultProps = {
  radius: 100,
  colors: [_theme.FlexTheme.PrimaryColor, _theme.FlexTheme.PrimaryRed, _theme.FlexTheme.PrimaryOrange, _theme.FlexTheme.PrimaryYellow, _theme.FlexTheme.PrimaryGreen, _theme.FlexTheme.PrimaryBlue, _theme.FlexTheme.PrimaryGrey, _theme.FlexTheme.PrimaryGreyLight, _theme.FlexTheme.SecondaryColor],
  stroke: true,
  thickness: 20
};
FlexiPie.propTypes = {
  radius: _propTypes["default"].number,
  colors: _propTypes["default"].array,
  shade: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  xData: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  yData: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  legend: _propTypes["default"].bool,
  aspect: _propTypes["default"].bool,
  formattedTooltip: _propTypes["default"].bool,
  thickness: _propTypes["default"].number,
  stroke: _propTypes["default"].bool
};